export const USER_REQUEST = 'user-request';
export const USER_ERROR = 'user-error';
export const USER_SUCCESS = 'user-success';
export const USER_LOGOUT = 'user-logout';
